import styled, { css } from "styled-components";

export const Container = styled.div`
  ${() => css``}
`;

export const Settings = styled.img`
  ${() => css`
    cursor: pointer;
  `}
`;
